import moment from 'moment/moment'

export default {
    name: 'datepicker',
    props: {
        value: {
        },
        format: {
            type: String,
            default: 'YYYY-MM-DD'
        },
        lang: {
            type: String,
            default: 'en'
        }
    },
    data() {
        return {
            days: {
                en: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                ru: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
            },
            today: null,
            month: null,
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.today = moment().startOf('day')

                if (moment(value, this.format, true).isValid()) {
                    this.month = moment(value, this.format, true).startOf('month').format()
                } else {
                    this.month = moment().startOf('month').format()
                }
            }
        }
    },
    computed: {
        grid() {
            moment.locale(this.lang)

            let month = []
            let week = []
            let date = moment(this.month)
            let daysInMonth = date.daysInMonth()
            let dayIndex = date.weekday()
            let count = daysInMonth + dayIndex

            if (count % 7 > 0) {
                count += (7 - count % 7)
            }

            date = date.subtract(dayIndex, 'days')

            for (let i = 1; i <= count; i++) {
                week.push({
                    date: date.format(),
                    num: date.format('D'),
                    otherMonth: (i < dayIndex + 1) || (i >= daysInMonth + dayIndex + 1),
                    selected: date.isSame(moment(this.value, this.format)),
                    today: this.today.isSame(date),
                })

                if (i % 7 === 0) {
                    month.push(week)
                    week = []
                }

                date.add(1, 'days')
            }

            return month
        },
    },
    methods: {
        prevMonth() {
            this.month = moment(this.month).subtract(1, 'months').format()
        },
        nextMonth() {
            this.month = moment(this.month).add(1, 'months').format()
        },
        select(day) {
            this.$emit('input', moment(day.date).format(this.format));
        },
    },
}



// WEBPACK FOOTER //
// ./src/components/ext/datepicker/datepicker.js